import React from "react";
import { Navbar as BsNavbar, Form as BsForm, Container as BsContainer } from "react-bootstrap";
import xss from "xss";

import { SearchIcon } from "./icons";

class Navbar extends React.Component {
  constructor(props) {
    super(props);
    this._page = 1;
    this._rows = 10;
    this._search = "";
    this._changed = false;
    // bind event listeners to this
    this.setRows = this.setRows.bind(this);
    this.setSearch = this.setSearch.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);
  }

  get page() {
    if (!isNaN(this.props.page)) return this.props.page;
    return this._page;
  }

  get rows() {
    if (!isNaN(this.props.rows)) return this.props.rows;
    return this._rows;
  }

  get search() {
    if (typeof this.props.search === "string") return this.props.search;
    if (this.props.search && typeof this.props.search.search === "string") return this.props.search.search;
    return this._search;
  }

  get changed() {
    if (typeof this.props.changed === "boolean") return this.props.changed;
    return this._changed;
  }

  onChange(change) {
    // TODO update own local variables that are changed if no props are provided
    if (typeof this.props.onChange !== "function") return;
    this.props.onChange(change);
  }

  onKeyPress(e) {
    if (!e || e.key !== "Enter") return;
    // do not send Form on RETURN
    e.preventDefault();
    e.currentTarget.blur();
    return false;
  }

  setRows(e) {
    if (!e || !e.target) return;
    let rows = Number(e.target.value) || 10;
    this.onChange({ rows });
  }

  setSearch(e) {
    if (!e || !e.target) return;
    let search = xss(e.target.value);
    this.onChange({ search });
  }

  selectAll() {
    return true;
  }

  render() {
    const searchListe = typeof this.props.searchListe === "function" ? this.props.searchListe : this.selectAll;
    const Pagination = this.props.pagination ? this.props.pagination : (_props) => {};
    const data = Array.isArray(this.props.list) ? this.props.list : [];
    const treffer = data.filter(item => searchListe(item, this.props.search, this.changed)).length;
    const length = data.length;
    let start = 1 + (this.page - 1) * this.rows;
    let end = start + this.rows - 1;
    if (length <= this.rows) {
      start = length ? 1 : 0;
      end = length;
    } else {
      if (end > length) end = length;
    }

    return (
      <BsNavbar className="d-flex justify-content-between align-center">
        <BsContainer className="flex-wrap">
          <BsNavbar.Brand>{this.props.brand}: {treffer < length
            ? <span>gefunden {treffer} aus {length}</span>
            : <span>{start} - {end} von {length}</span>
          }</BsNavbar.Brand>
          <Pagination
            list={data}
            page={this.page}
            rows={this.rows}
            search={this.props.search}
            searchListe={searchListe}
            changed={this.changed}
            disabled={this.props.disabled}
            onChange={this.onChange}
          />
          <BsForm.Group controlId="rows" className="d-flex align-items-center">
            <span className="pe-one-half">Zeige</span>
            <BsForm.Select
              aria-label="Zeilen pro Seite"
              value={this.props.rows}
              disabled={this.props.disabled}
              aria-disabled={String(!!this.props.disabled)}
              onChange={this.setRows}
            >
              <option value="10">10</option>
              {data.length > 20
                ? <option value="20">20</option>
                : null
              }
              {data.length > 50
                ? <option value="50">50</option>
                : null
              }
              {data.length > 100
                ? <option value="100">100</option>
                : null
              }
              {data.length > 10
                ? <option value={data.length}>alle</option>
                : null
              }
            </BsForm.Select>
            <span aria-hidden className="ps-one-half nowrap">
              pro Seite
            </span>
          </BsForm.Group>
          <BsForm.Group controlId="search" className="d-flex align-items-center">
            <BsForm.Control
              placeholder="Suche im Ergebnis"
              aria-label="Suche im Ergebnis"
              value={this.search}
              disabled={this.props.disabled}
              aria-disabled={String(!!this.props.disabled)}
              onChange={this.setSearch}
              onKeyPress={this.onKeyPress} />
            <SearchIcon className="ms-one-half" />
          </BsForm.Group>
          {this.props.children}
        </BsContainer>
      </BsNavbar>
    );
  }
}
export default Navbar;
